module.exports = __webpack_public_path__ + "media/images/new_logo-e0dcc110.png";